<template>
  <div>
    <v-layout row>
      <v-flex xs12 sm8 offset-sm2 md6 offset-md3 lg4 offset-lg4 class="mt-3 mb-3">
        <v-card>
          <progress-bar color="accent" :show="busy"></progress-bar>
          <v-toolbar color="grey lighten-4">
            <v-toolbar-title>Ihre Betriebe</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-tooltip bottom>
              <v-icon slot="activator" color="secondary">info</v-icon>
              <span>Die von Ihnen gespeicherten Betriebe bleiben bis zum Löschen der Browserverlauf-Daten bestehen.</span>
            </v-tooltip>
          </v-toolbar>
          <span v-if="betriebe.length < 1">
            <div class="ma-3">Noch keine Betriebe gemerkt</div>
          </span>
          <v-list three-line v-else>
            <template v-for="(betrieb, id) in betriebe">
              <v-list-tile :key="betrieb.name" avatar ripple>
                
                <v-list-tile-avatar
                  size="70"
                  tile
                  style="width: 100px;"
                  class="mt-1"
                  v-if="betrieb.image_logo"
                >
                  <v-img
                    v-if="betrieb.image_logo"
                    :src="betrieb.image_logo"
                    aspect-ratio
                    contain
                    max-width="100"
                  ></v-img>
                </v-list-tile-avatar>

                <v-list-tile-avatar
                  size="70"
                  tile
                  style="width: 100px;"
                  class="mt-1"
                  v-else-if="betrieb.innungen.length < 1"
                >
                  <v-img
                    v-if="betrieb.innung.logo"
                    :src="betrieb.innung.logo"
                    aspect-ratio
                    contain
                    max-width="100"
                  ></v-img>
                </v-list-tile-avatar>

                <v-list-tile-avatar
                  size="70"
                  tile
                  style="width: 100px;"
                  class="mt-1"
                  v-else-if="betrieb.innungen.length > 0 "
                >
                  <template v-for="innungen in betrieb.innungen.slice(0,1)">
                    <v-img
                      :src="innungen.logo"
                      :key="innungen.id"
                      aspect-ratio
                      contain
                      max-width="100"
                    ></v-img>
                  </template>
                </v-list-tile-avatar>

                <v-list-tile-content>
                  <v-list-tile-title>{{ betrieb.vollername }}</v-list-tile-title>
                  <v-list-tile-sub-title
                    class="text--primary"
                    v-if="betrieb.innung"
                  >{{ betrieb.innung.name }}</v-list-tile-sub-title>
                  <v-list-tile-sub-title>
                    <v-icon small>phone</v-icon>
                    {{ betrieb.telefon }}  
                  </v-list-tile-sub-title>
                </v-list-tile-content>
                <v-list-tile-action>
                  <v-list-tile-action-text>
                    <v-btn flat left :to="{name: 'showCompany', params: {id: betrieb.slug}}">Profil</v-btn>
                  </v-list-tile-action-text>
                  <listing-save :company="betrieb"></listing-save>
                </v-list-tile-action>
              </v-list-tile>
                <!-- {{ betrieb }}  -->
              <v-divider v-if="id + 1 < betriebe.length" :key="id"></v-divider>
            </template>
          </v-list>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import store from '~/store'
// import { mapGetters } from 'vuex'

import axios from 'axios'

import ListingSave from '~/components/ListingSave.vue'

export default {
  components: {
    // StripePay,
    ListingSave
    // MailSend,
  },
  data () {
    return {
      busy: false,
      betriebe: [],
      betrieb: '',
      infos: {
        title: '',
        address: '',
        content: '',
        email: '',
        page: ''
      }
    }
  },
  created () {
    // this.fetchData()
  },
  beforeRouteEnter (to, from, next) {
    //   this.busy = true
    // const app = this

    if (store.getters.fetchGemerkt) {
      var params = {
        gemerkte: [store.getters.fetchGemerkt.saved]
      }

      axios
        .get('/api/v1/gemerkt/', {
          params: params
        })
        .then(function (resp) {
          //   app.betriebe = resp.data
          // console.log('daten geladen: ')
          // console.log(resp.data)
          next(vm => (vm.betriebe = resp.data))
        })
        .catch(function (error) {
          //  console.log('gemerkte error')
          console.log(error)
        })
    }
    //  this.busy = false
  },
  // beforeRouteUpdate(to, from, next) {
  //   //this.anzeige.anzeige = null
  //   let app = this
  //   // let id = app.$route.params.id;
  //   axios
  //     .get('/api/v1/anzeige/' + to.params.id)
  //     .then(resp => {
  //       this.setData(resp.data)
  //       // app.anzeige = resp.data
  //       next()
  //       // next(vm => (vm.anzeige = resp.data))
  //     })
  //     .catch(error => {
  //       if (error.response) {
  //         console.log('err response')
  //         console.log(error.response.data)
  //         console.log(error.response.status)
  //         console.log(error.response.headers)
  //       } else if (error.request) {
  //         // console.log('request putt')
  //         //   console.log(error.request);
  //       } else {
  //         console.log('Error', error.message)
  //       }

  //       //  app.$router.push('/')
  //       next('/404')
  //     })
  // },
  methods: {
    // fetchData() {
    //   this.busy = true
    //   let app = this
    //   if (app.$store.getters.fetchGemerkt) {
    //     var params = {
    //       gemerkte: [app.$store.getters.fetchGemerkt.saved]
    //     }
    //     axios
    //       .get('/api/v1/gemerkt/', {
    //         params: params
    //       })
    //       .then(function(resp) {
    //         app.betriebe = resp.data
    //       })
    //       .catch(function(error) {
    //         //  console.log('gemerkte error')
    //         //  console.log(error)
    //       })
    //   }
    //   this.busy = false
    // }
  },
  metaInfo () {
    return { title: 'Gemerkte Betriebe' }
  }
}
</script>


